import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthFacade} from 'af-services';



@Component({
  selector: 'app-google-login',
  templateUrl: './google-login.component.html',
  styleUrls: ['./google-login.component.scss']
})
export class GoogleLoginComponent implements OnInit {

  @Input() isModal = false;
  @Input() saveAndRedirectToCurrentPage = false;
  @Output() done = new EventEmitter<any>();

  constructor(private authFacade: AuthFacade) {
  }


  async ngOnInit() {


  }

  showLoading() {
    if (this.isModal) {
      this.authFacade.loginViaGoogleInModal(() => {
        this.done.emit();

      });
    } else {
      if (this.saveAndRedirectToCurrentPage) {
        localStorage.setItem('redirectTo', window.location.href);
      } else {
        localStorage.removeItem('redirectTo');
      }
      this.authFacade.googleLogin('btnGoogle');
    }

  }
}
